export interface IPageNavigationSetting {
        skip: number;
        take: number;
        count: number;
    }

    export class PageNavigationSetting implements IPageNavigationSetting {
        skip: number;
        take: number;
        count: number;
    }